import React, { useState } from 'react';
import GE2 from '../assets/images/2.jpg';
import FaqSection from '../components/FaqSection';
import Feature55 from "./../components/Feature55";
import HowWeHelp from '../components/HowWeHelp';

function About() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div >
      <Feature55/>
      <HowWeHelp/>
 <FaqSection/>
    
    </div>
  );
}

export default About;
